import { Box, Grid, useTheme } from '@mui/material'
import { Color } from '../../../chess/types'
import { LoginState } from '../../../sharedComponents/src/globalHeader/GlobalHeader'
import { useStoreState } from '../../../store/hooks'
import { CycleRewardsBar } from '../components/CycleRewardsBar'
import { PuzzleQuestControls } from '../components/PuzzleQuestControls'
import { PuzzleQuestHeader } from '../components/PuzzleQuestHeader'
import { PuzzleQuestNavigation } from '../components/PuzzleQuestNavigation'
import { PuzzleQuestStatusHeader } from '../components/PuzzleQuestStatusHeader'
import { StepChallengeProgress } from '../components/StepChallengeProgress'
import { StepCooldown } from '../components/StepCooldown'

const DesktopCycleProgress = () => {
    const userState = useStoreState((state) => state.userData.state)
    const cycleProgress = useStoreState((state) => state.puzzleQuestView.cycleProgress)

    if (userState !== LoginState.LOGGED_IN || !cycleProgress) return null

    return (
        <CycleRewardsBar
            rewardsTotal={cycleProgress.rewardsTotal}
            rewardsThreshold={cycleProgress.rewardsThreshold}
            season={cycleProgress.season}
            endTime={cycleProgress.endTime}
            rewards={cycleProgress.rewards}
        />
    )
}

export const DesktopPQ = () => {
    const theme = useTheme()
    const stepProgress = useStoreState((state) => state.puzzleQuestView.stepProgress)
    const currentPuzzleNumber = useStoreState((state) => state.puzzleQuestView.currentPuzzleNumber)
    const myColor = useStoreState((state) => state.puzzleQuestView.myColor)
    const puzzleState = useStoreState((state) => state.puzzleQuestView.puzzleState)
    const hint = useStoreState((state) => state.puzzleQuestView.hint)
    const showSolution = useStoreState((state) => state.puzzleQuestView.showSolution)

    // Determine status header state
    const getStatusType = (): 'toMove' | 'puzzleSolved' | 'puzzleFailed' | 'hintUsed' | 'solution' => {
        if (showSolution) return 'solution'
        if (puzzleState === true) return 'puzzleSolved'
        if (puzzleState === false) return 'puzzleFailed'
        if (hint) return 'hintUsed'
        return 'toMove'
    }

    return (
        <>
            <Grid
                container
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    flexWrap: 'nowrap',
                    backgroundColor: 'background.default',
                    borderRadius: '0',
                    padding: 0,
                    gap: 1,
                }}
            >
                {stepProgress.completed ? (
                    <StepCooldown />
                ) : (
                    <>
                        <PuzzleQuestHeader />
                        <Box
                            sx={{
                                border: `3px solid ${theme.palette.orange.main}`,
                                flexGrow: 1,
                                justifyContent: 'space-evenly',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            {/* Header */}
                            {/* Status Header */}

                            <PuzzleQuestStatusHeader
                                status={getStatusType()}
                                playerColor={myColor === Color.White ? 'white' : 'black'}
                            />

                            {/* Divider */}
                            <Box sx={{ width: '100%', height: '2px', backgroundColor: '#283037' }} />

                            {/* Step Challenge Progress */}

                            <StepChallengeProgress
                                progress={stepProgress.progress}
                                currentPuzzle={currentPuzzleNumber}
                                endTime={stepProgress.endTime}
                            />

                            {/* Divider */}
                            <Box sx={{ width: '100%', height: '2px', backgroundColor: '#283037' }} />

                            {/* Cycle Progress */}

                            <DesktopCycleProgress />
                        </Box>
                    </>
                )}
            </Grid>
            {!stepProgress.completed ? <PuzzleQuestControls /> : <PuzzleQuestNavigation />}
        </>
    )
}
